import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription, Observable } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { PrinterConfigModalComponent } from './shared/components/printer-config-modal/printer-config-modal.component';
import { printerFeatureKey, PrinterState } from './store/printer/printer.reducer';
import { Router } from '@angular/router';
interface AppState {
  printer: PrinterState;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DialogService]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'cangas_aventura';
  printerConfiguredSubscription?: Subscription;
  printerConfigured$: Observable<boolean>;
  ref: any;


  printerIgnored$: Observable<boolean>;

  constructor(
    private store: Store<AppState>,
    public dialogService: DialogService,
    public viewContainerRef: ViewContainerRef,
    private router: Router
  ) {
    this.printerConfigured$ = this.store.pipe(select(printerFeatureKey), select('isConnected'));
    this.printerIgnored$ = this.store.pipe(select(printerFeatureKey), select('isIgnored'));
  }

  ngOnInit(): void {
    console.log('AppComponent: Verificando si hay impresora en localStorage');
    const printerName = localStorage.getItem('printerDevice');
    const printerIgnored = localStorage.getItem('printerIgnored') === 'true';
    console.log('AppComponent: Nombre de impresora en localStorage:', printerName);
    console.log('AppComponent: Estado de impresora ignorada:', printerIgnored);

    if (!printerIgnored) {
      console.log('AppComponent: Impresora en estado ignorado, no mostrando modal');
      this.printerConfiguredSubscription = this.printerConfigured$.subscribe(
        (isConnected) => {
          console.log('AppComponent: Estado de isConnected:', isConnected);

          let isIgnored = false;
          this.printerIgnored$.subscribe(ignored => {
            isIgnored = ignored;
          }).unsubscribe();

          if (!isConnected && this.router.url === '/panel/dashboard' && !printerName && localStorage.getItem('me')) {
            console.log('AppComponent: Abriendo modal de configuración de impresora (no hay configuración)');
            this.openPrinterConfigModal();
          } else if (!isConnected && printerName) {
            console.log('AppComponent: No abriendo modal aunque no esté conectada porque ya hay configuración guardada o está ignorada');
          } else if (!localStorage.getItem('me')) {
            console.log('AppComponent: No abriendo modal porque el usuario no está logueado');
          }
        }
      );
    }

    this.store.pipe(select(printerFeatureKey)).subscribe(printerState => {
      console.log('AppComponent: Estado completo de la impresora:', printerState);
    });

  }

  ngOnDestroy(): void {
    if (this.printerConfiguredSubscription) {
      this.printerConfiguredSubscription.unsubscribe();
    }
  }

  openPrinterConfigModal(): void {
    this.ref = this.dialogService.open(PrinterConfigModalComponent, {
      header: 'Configurar Impresora',
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false
    });

    this.ref.onClose.subscribe((printer: any) => {
      if (printer) {
        console.log('Printer configured', printer);
      }
    });
  }
}
